import { request } from './http';
import { config } from '../utils/config';
import type { CommandAction, GameServer, GameServerCommand, GameServerLogEntry, GameServerMetric, LogLevel } from '../types/models';

const root = config.operationsBase.endsWith('/') ? config.operationsBase : `${config.operationsBase}/`;
const unwrap = <T>(data: T[] | { results?: T[] }): T[] => Array.isArray(data) ? data : data.results || [];

export const operationsApi = {
  listServers: async () => unwrap(await request<GameServer[] | { results?: GameServer[] }>(`${root}servers/`)),
  getServer: (id: string) => request<GameServer>(`${root}servers/${encodeURIComponent(id)}/`),
  metrics: async (id: string, limit = 100) => unwrap(await request<GameServerMetric[] | { results?: GameServerMetric[] }>(`${root}servers/${encodeURIComponent(id)}/metrics/?limit=${limit}`)),
  logs: async (id: string, level?: LogLevel | '', limit = 200) => {
    const query = new URLSearchParams({ limit: String(limit) });
    if (level) query.set('level', level);
    return unwrap(await request<GameServerLogEntry[] | { results?: GameServerLogEntry[] }>(`${root}servers/${encodeURIComponent(id)}/logs/?${query}`));
  },
  commands: async (id: string) => unwrap(await request<GameServerCommand[] | { results?: GameServerCommand[] }>(`${root}servers/${encodeURIComponent(id)}/commands/`)),
  createCommand: (id: string, action: CommandAction) => request<GameServerCommand>(`${root}servers/${encodeURIComponent(id)}/commands/create/`, { method: 'POST', body: JSON.stringify({ action }) }),
};
